import { Helmet } from 'react-helmet'
import * as React from 'react'

export default function AccessControlSettingsPage() {
  return (
    <div className="pt-6">
      <Helmet>
        <title>Settings &gt; Access Control</title>
      </Helmet>

      <h2>Access Control</h2>
      <p className="italic text-slate-500">Nothing to se here...</p>
    </div>
  )
}
